import CourtContainer from './CourtContainer';

export default CourtContainer;
